import { render, staticRenderFns } from "./ResourceBack.vue?vue&type=template&id=2ff1da50&scoped=true"
import script from "./ResourceBack.vue?vue&type=script&lang=js"
export * from "./ResourceBack.vue?vue&type=script&lang=js"
import style0 from "./ResourceBack.vue?vue&type=style&index=0&id=2ff1da50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff1da50",
  null
  
)

export default component.exports